import { useEffect } from 'react';
import useTracking from 'hooks/useTracking/useTracking';
import { buyerViewCheckoutEvent } from 'libs/common/event-tracker/events';

const useTrackViewExtraServiceCheckout = _ref => {
  let {
    screen,
    orderId,
    orderType,
    shouldTrack
  } = _ref;
  const {
    track
  } = useTracking();
  useEffect(() => {
    if (!orderId || !shouldTrack) return;
    track(buyerViewCheckoutEvent({
      screen,
      orderId,
      orderType
    }));
  }, [track, screen, orderId, orderType, shouldTrack]);
};

export default useTrackViewExtraServiceCheckout;